import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './styles.module.sass';
import LegalCost from 'components/page/CollectionCaseEditor/ExpansionPanelPenaltyAndLegalCost/LegalCosts/LegalCost';
import AddIcon from '@material-ui/icons/AddCircleOutline';
import RemoveIcon from '@material-ui/icons/RemoveCircleOutline';
import ButtonIcon from 'components/common/ButtonIcon';
import {ENTITY_STATE_DELETE} from 'utils/constants';
import Question from 'components/common/Question';

class LegalCosts extends PureComponent {

  handlerOnAdd = (legalCost) => {
    if (!legalCost) legalCost = {};

    let {onChange, value: legalCostList} = this.props;
    if (!legalCostList) legalCostList = [];

    const nextLegalCostList = legalCostList.concat(legalCost);
    if (onChange) onChange(nextLegalCostList);
  };

  handlerOnChange = (currentLegalCost, nextLegalCost) => {
    const {onChange, value: legalCostList} = this.props;

    const nextLegalCostList = legalCostList.map(a => a === currentLegalCost ? nextLegalCost : a);
    if (onChange) onChange(nextLegalCostList);
  };

  handlerOnDelete = (legalCost) => {
    const {onChange, value: legalCostList} = this.props;

    const nextLegalCostList = legalCostList
      .filter(a => !(a === legalCost && a.id !== 0 && !a.id))
      .map(a => {if (a === legalCost) a.state = ENTITY_STATE_DELETE; return a });

    if (onChange) onChange(nextLegalCostList);
  };

  render() {
    let {value: legalCostList, className: classBox} = this.props;
    if (legalCostList) legalCostList = legalCostList.filter(a => a && a.state !== ENTITY_STATE_DELETE);

    return (
      <div className={cx(styles.box, classBox)}>
        <div className={styles.legalCostBox}>
          {legalCostList && legalCostList.map(legalCost =>
            (
              <LegalCost
                className={styles.legalCost}
                value={legalCost}
                onChange={(v) => this.handlerOnChange(legalCost, v)}
                rightMenu={
                  <Question
                    header="Вы уверены что хотите удалить элемент?"
                    ok="Удалить"
                    onOk={() => this.handlerOnDelete(legalCost)}
                  >
                    <ButtonIcon tooltip={'Удалить'}>
                      <RemoveIcon className={styles.icon}/>
                    </ButtonIcon>
                  </Question>}
              />
            )
          )}
        </div>
        <ButtonIcon tooltip={'Добавить судебную издержку'} onClick={() => this.handlerOnAdd()}><AddIcon/></ButtonIcon>
      </div>
    );
  }
}

LegalCosts.propTypes = {
  className: PropTypes.string,
  value: PropTypes.arrayOf({
    sum: PropTypes.number,
    attachFileList: PropTypes.arrayOf({
      id: PropTypes.string,
      fileStorageId: PropTypes.string,
      name: PropTypes.string,
    }),
    comment: PropTypes.string,
  }),
  onChange: PropTypes.func
};

export default LegalCosts;


// WEBPACK FOOTER //
// ./src/components/page/CollectionCaseEditor/ExpansionPanelPenaltyAndLegalCost/LegalCosts/LegalCosts.jsx